module.exports = __webpack_public_path__ + "fonts/museo-sans-900-webfont.7079cff.woff2";